import Phaser from "phaser";
import { IdlePreview } from "@/game/objects/IdlePreview";

export class IdleStage extends Phaser.GameObjects.Container {
  private preview: IdlePreview;
  private clickHandler: (() => void) | null = null;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    scene.add.existing(this);

    const floor = scene.add.rectangle(0, 48, 220, 12, 0x2a3548, 1);
    this.preview = new IdlePreview(scene, 0, 0);
    this.add([floor, this.preview]);

    const hit = scene.add.zone(0, 0, 120, 140).setInteractive({ useHandCursor: true });
    this.add(hit);
    hit.on("pointerdown", () => this.clickHandler?.());
  }

  onClick(handler: () => void): void {
    this.clickHandler = handler;
  }

  pulse(): void {
    this.preview.playBump();
  }
}
